"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setThreeObjectMaterial = void 0;
var realmforge_common_1 = require("realmforge-common");
var realms_three_1 = __importDefault(require("realms-three"));
var realmforge_common_2 = require("realmforge-common");
var hexString_1 = require("./hexString");
var dataObjectMaterialWrappingMode_1 = require("./dataObjectMaterialWrappingMode");
/*
 * Sets the new three object material
 */
var setThreeObjectMaterial = function (obj, material, methods) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, vertexShader, fragmentShader, mapUniforms, _b, _c, _d, _e, _f, _g, _h, _j, texture;
    var _k;
    return __generator(this, function (_l) {
        switch (_l.label) {
            case 0:
                if (!(obj instanceof realms_three_1.default.Mesh)) {
                    throw new Error("Object is not a mesh but of type ".concat(obj.type));
                }
                // Dispose the old material
                obj.material.dispose();
                if (material === null) {
                    obj.material = new realms_three_1.default.MeshPhongMaterial({
                        color: (0, hexString_1.hexStringToNumber)(realmforge_common_2.DEFAULT_SHAPE_COLOR),
                    });
                    return [2 /*return*/];
                }
                _a = material.type;
                switch (_a) {
                    case realmforge_common_1.DataObjectMaterialType.MeshPhongMaterial: return [3 /*break*/, 1];
                    case realmforge_common_1.DataObjectMaterialType.MeshToonMaterial: return [3 /*break*/, 2];
                    case realmforge_common_1.DataObjectMaterialType.MeshShaderMaterial: return [3 /*break*/, 3];
                }
                return [3 /*break*/, 10];
            case 1:
                {
                    obj.material = new realms_three_1.default.MeshPhongMaterial();
                    return [3 /*break*/, 10];
                }
                _l.label = 2;
            case 2:
                {
                    obj.material = new realms_three_1.default.MeshToonMaterial();
                    return [3 /*break*/, 10];
                }
                _l.label = 3;
            case 3:
                vertexShader = material.vertexShaderCodeDocumentId
                    ? methods.getCodeDocument(material.vertexShaderCodeDocumentId)
                    : undefined;
                fragmentShader = material.fragmentShaderCodeDocumentId
                    ? methods.getCodeDocument(material.fragmentShaderCodeDocumentId)
                    : undefined;
                mapUniforms = function (uniforms) { return __awaiter(void 0, void 0, void 0, function () {
                    var out, _a, _b, _c, k, v, _d, texture, e_1_1;
                    var e_1, _e;
                    return __generator(this, function (_f) {
                        switch (_f.label) {
                            case 0:
                                out = {};
                                _f.label = 1;
                            case 1:
                                _f.trys.push([1, 11, 12, 13]);
                                _a = __values(Object.entries(uniforms)), _b = _a.next();
                                _f.label = 2;
                            case 2:
                                if (!!_b.done) return [3 /*break*/, 10];
                                _c = __read(_b.value, 2), k = _c[0], v = _c[1];
                                _d = v.type;
                                switch (_d) {
                                    case realmforge_common_1.UniformType.Vector2: return [3 /*break*/, 3];
                                    case realmforge_common_1.UniformType.Vector3: return [3 /*break*/, 4];
                                    case realmforge_common_1.UniformType.Image: return [3 /*break*/, 5];
                                    case realmforge_common_1.UniformType.Time: return [3 /*break*/, 7];
                                }
                                return [3 /*break*/, 8];
                            case 3:
                                {
                                    out[k] = {
                                        value: new realms_three_1.default.Vector2(v.defaultValue.x, v.defaultValue.y),
                                    };
                                    return [3 /*break*/, 9];
                                }
                                _f.label = 4;
                            case 4:
                                {
                                    out[k] = {
                                        value: new realms_three_1.default.Vector3(v.defaultValue.x, v.defaultValue.y, v.defaultValue.z),
                                    };
                                    return [3 /*break*/, 9];
                                }
                                _f.label = 5;
                            case 5: return [4 /*yield*/, methods.getAssetTexture(v.defaultValue)];
                            case 6:
                                texture = _f.sent();
                                if (texture) {
                                    out[k] = {
                                        value: texture,
                                    };
                                }
                                return [3 /*break*/, 9];
                            case 7:
                                {
                                    out[k] = {
                                        value: 0,
                                    };
                                    return [3 /*break*/, 9];
                                }
                                _f.label = 8;
                            case 8:
                                {
                                    out[k] = {
                                        value: v.defaultValue,
                                    };
                                    return [3 /*break*/, 9];
                                }
                                _f.label = 9;
                            case 9:
                                _b = _a.next();
                                return [3 /*break*/, 2];
                            case 10: return [3 /*break*/, 13];
                            case 11:
                                e_1_1 = _f.sent();
                                e_1 = { error: e_1_1 };
                                return [3 /*break*/, 13];
                            case 12:
                                try {
                                    if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                                }
                                finally { if (e_1) throw e_1.error; }
                                return [7 /*endfinally*/];
                            case 13: return [2 /*return*/, out];
                        }
                    });
                }); };
                _b = obj;
                _d = (_c = realms_three_1.default.ShaderMaterial).bind;
                _e = [__assign(__assign({}, (vertexShader ? { vertexShader: vertexShader.contents } : {})), (fragmentShader ? { fragmentShader: fragmentShader.contents } : {}))];
                _k = {};
                _f = [{}];
                if (!(0, realmforge_common_1.isGLSLCodeDocumentType)(vertexShader === null || vertexShader === void 0 ? void 0 : vertexShader.type)) return [3 /*break*/, 5];
                return [4 /*yield*/, mapUniforms(vertexShader.uniforms)];
            case 4:
                _g = _l.sent();
                return [3 /*break*/, 6];
            case 5:
                _g = {};
                _l.label = 6;
            case 6:
                _h = [__assign.apply(void 0, _f.concat([(_g)]))];
                if (!(0, realmforge_common_1.isGLSLCodeDocumentType)(fragmentShader === null || fragmentShader === void 0 ? void 0 : fragmentShader.type)) return [3 /*break*/, 8];
                return [4 /*yield*/, mapUniforms(fragmentShader.uniforms)];
            case 7:
                _j = _l.sent();
                return [3 /*break*/, 9];
            case 8:
                _j = {};
                _l.label = 9;
            case 9:
                _b.material = new (_d.apply(_c, [void 0, __assign.apply(void 0, _e.concat([(_k.uniforms = __assign.apply(void 0, _h.concat([(_j)])), _k)]))]))();
                return [2 /*return*/];
            case 10:
                obj.material.color = material.color
                    ? (0, hexString_1.hexStringToColor)(material.color)
                    : (0, hexString_1.hexStringToColor)(realmforge_common_2.DEFAULT_SHAPE_COLOR);
                if (!material.mapAssetId) return [3 /*break*/, 12];
                return [4 /*yield*/, methods.getAssetTexture(material.mapAssetId)];
            case 11:
                texture = _l.sent();
                if (!(obj instanceof realms_three_1.default.Mesh) || texture === null) {
                    if (texture === null) {
                        console.warn("Missing texture ".concat(material.mapAssetId));
                    }
                    return [2 /*return*/];
                }
                // Clear previous texture
                if (obj.material.map instanceof realms_three_1.default.Texture) {
                    obj.material.map.dispose();
                }
                // Add wrapS and wrapT if given
                if (material.wrapS) {
                    texture.wrapS = (0, dataObjectMaterialWrappingMode_1.dataObjectMaterialWrappingModeToThree)(material.wrapS);
                }
                if (material.wrapT) {
                    texture.wrapT = (0, dataObjectMaterialWrappingMode_1.dataObjectMaterialWrappingModeToThree)(material.wrapT);
                }
                if (material.repeat) {
                    texture.repeat = new realms_three_1.default.Vector2(material.repeat.x, material.repeat.y);
                }
                // Update texture
                obj.material.map = texture;
                obj.material.needsUpdate = true;
                obj.material.name = material.mapAssetId;
                return [3 /*break*/, 13];
            case 12:
                obj.material.map = null;
                obj.material.name = "";
                _l.label = 13;
            case 13: return [2 /*return*/];
        }
    });
}); };
exports.setThreeObjectMaterial = setThreeObjectMaterial;
